import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";

import { AppComponent } from "./app.component";
import { HomeComponent } from "./views/home/home.component";
import { NavMenuComponent } from "./components/nav-menu/nav-menu.component";
import { LoginComponent } from "./views/login/login.component";
import { AmeritradeLoginComponent } from "./views/ameritradeLogin/ameritradeLogin.component";
import { AuthComponent } from "./views/auth/auth.component";

// pg
import { MenubarModule } from "primeng/menubar";
import { AuthorizeGuard } from "./guards/authorize.guard";

import { AgGridModule } from "ag-grid-angular";

import { DecimalPipe } from "@angular/common";
import { PossibleTradesComponent } from "./views/possible-trades/possible-trades.component";
import { FiltersComponent } from "./views/filters/filters.component";
import { OptionFilterPipe } from "./views/possible-trades/option-filter";
import { TradeFilterPipe } from "./views/possible-trades/trades-filter";

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,

    HomeComponent,
    FiltersComponent,

    PossibleTradesComponent,

    LoginComponent,
    AmeritradeLoginComponent,
    AuthComponent,
    OptionFilterPipe,
    TradeFilterPipe,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule.withComponents([]),
    MenubarModule,
    RouterModule.forRoot(
      [
        {
          path: "",
          component: HomeComponent,
          pathMatch: "full",
          canActivate: [AuthorizeGuard],
        },
        { path: "login", component: LoginComponent, pathMatch: "full" },
        {
          path: "ameritrade-login",
          component: AmeritradeLoginComponent,
          pathMatch: "full",
          canActivate: [AuthorizeGuard],
        },
        {
          path: "auth",
          component: AuthComponent,
          pathMatch: "full",
          canActivate: [AuthorizeGuard],
        },
        {
          path: "possible-trades/:symbol",
          component: PossibleTradesComponent,
          pathMatch: "full",
          canActivate: [AuthorizeGuard],
        },

        {
          path: "filters",
          component: FiltersComponent,
          pathMatch: "full",
          canActivate: [AuthorizeGuard],
        },
      ],
      { relativeLinkResolution: "legacy" }
    ),
  ],
  providers: [DecimalPipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
